module.exports = (theme) => ({
  ".preamble": {
    fontSize: theme("fontSize.xl"),
    fontFamily: theme("fontFamily.regular"),
    fontWeight: theme("fontWeight.medium"),
    lineHeight: theme("lineHeight.base"),
  },
  [`@media (min-width: ${theme("screens.sm")})`]: {
    ".preamble": {
      fontSize: theme("fontSize.3xl"),
      fontFamily: theme("fontFamily.regular"),
      fontWeight: theme("fontWeight.medium"),
      lineHeight: theme("lineHeight.xl"),
    },
  },
});
